import React from 'react';

export default function FacebookCarousel() {
  return (
    <div>
      Carousel not done yet
    </div>
  );
}
